import { jsx as _jsx } from "react/jsx-runtime";
export function InvalidXml() {
    return _jsx("div", { children: "Invalid XML!" });
}
//# sourceMappingURL=index.js.map